import { render, staticRenderFns } from "./DiscussComponent.vue?vue&type=template&id=b6416a40&scoped=true&"
import script from "./DiscussComponent.vue?vue&type=script&lang=js&"
export * from "./DiscussComponent.vue?vue&type=script&lang=js&"
import style0 from "./DiscussComponent.vue?vue&type=style&index=0&id=b6416a40&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6416a40",
  null
  
)

export default component.exports